import { staticText } from '../../../utils/translations/staticText';

export const baseTranslations = {
  dismiss: {
    _: 'Not Now',
    zh: '暫時不用',
  },
  confirm: {
    _: 'Proceed',
    zh: '確認',
  },
};
export const TRANSLATIONS = staticText(baseTranslations);
